export const getDiffBetweenArrays = <ArrayType extends { id: string | number }>(
  arr2: ArrayType[],
  arr1: ArrayType[]
): ArrayType[] => arr2.filter((file) => !arr1.find((submittedFile) => submittedFile.id === file.id));
